const A = "CONNECT", G = "DEFAULT";
var z = /* @__PURE__ */ ((u) => (u.GET_STATE = "get-state", u.GET_STATE_RESPONSE = "get-state-response", u.SET_STATE = "set-state", u.ON_CHANGE = "on-change", u.RESIZE = "resize", u))(z || {});
function J(u) {
  return u && u.__esModule && Object.prototype.hasOwnProperty.call(u, "default") ? u.default : u;
}
var C = { exports: {} }, T;
function K() {
  return T || (T = 1, (function(u) {
    var n = (() => {
      var o = Object.defineProperty, l = Object.getOwnPropertyDescriptor, p = Object.getOwnPropertyNames, g = Object.getOwnPropertySymbols, b = Object.prototype.hasOwnProperty, N = Object.prototype.propertyIsEnumerable, O = (_, r, d) => r in _ ? o(_, r, { enumerable: !0, configurable: !0, writable: !0, value: d }) : _[r] = d, x = (_, r) => {
        for (var d in r || (r = {}))
          b.call(r, d) && O(_, d, r[d]);
        if (g)
          for (var d of g(r))
            N.call(r, d) && O(_, d, r[d]);
        return _;
      }, F = (_, r) => {
        for (var d in r)
          o(_, d, { get: r[d], enumerable: !0 });
      }, H = (_, r, d, D) => {
        if (r && typeof r == "object" || typeof r == "function")
          for (let w of p(r))
            !b.call(_, w) && w !== d && o(_, w, { get: () => r[w], enumerable: !(D = l(r, w)) || D.enumerable });
        return _;
      }, j = (_) => H(o({}, "__esModule", { value: !0 }), _), e = (_, r, d) => O(_, typeof r != "symbol" ? r + "" : r, d), S = {};
      F(S, {
        DEFAULT_OPTIONS: () => P,
        DEFAULT_UUID_LENGTH: () => v,
        default: () => B
      });
      var $ = "5.3.2", v = 6, P = {
        dictionary: "alphanum",
        shuffle: !0,
        debug: !1,
        length: v,
        counter: 0
      }, y = class {
        constructor(r = {}) {
          e(this, "counter"), e(this, "debug"), e(this, "dict"), e(this, "version"), e(this, "dictIndex", 0), e(this, "dictRange", []), e(this, "lowerBound", 0), e(this, "upperBound", 0), e(this, "dictLength", 0), e(this, "uuidLength"), e(this, "_digit_first_ascii", 48), e(this, "_digit_last_ascii", 58), e(this, "_alpha_lower_first_ascii", 97), e(this, "_alpha_lower_last_ascii", 123), e(this, "_hex_last_ascii", 103), e(this, "_alpha_upper_first_ascii", 65), e(this, "_alpha_upper_last_ascii", 91), e(this, "_number_dict_ranges", {
            digits: [this._digit_first_ascii, this._digit_last_ascii]
          }), e(this, "_alpha_dict_ranges", {
            lowerCase: [this._alpha_lower_first_ascii, this._alpha_lower_last_ascii],
            upperCase: [this._alpha_upper_first_ascii, this._alpha_upper_last_ascii]
          }), e(this, "_alpha_lower_dict_ranges", {
            lowerCase: [this._alpha_lower_first_ascii, this._alpha_lower_last_ascii]
          }), e(this, "_alpha_upper_dict_ranges", {
            upperCase: [this._alpha_upper_first_ascii, this._alpha_upper_last_ascii]
          }), e(this, "_alphanum_dict_ranges", {
            digits: [this._digit_first_ascii, this._digit_last_ascii],
            lowerCase: [this._alpha_lower_first_ascii, this._alpha_lower_last_ascii],
            upperCase: [this._alpha_upper_first_ascii, this._alpha_upper_last_ascii]
          }), e(this, "_alphanum_lower_dict_ranges", {
            digits: [this._digit_first_ascii, this._digit_last_ascii],
            lowerCase: [this._alpha_lower_first_ascii, this._alpha_lower_last_ascii]
          }), e(this, "_alphanum_upper_dict_ranges", {
            digits: [this._digit_first_ascii, this._digit_last_ascii],
            upperCase: [this._alpha_upper_first_ascii, this._alpha_upper_last_ascii]
          }), e(this, "_hex_dict_ranges", {
            decDigits: [this._digit_first_ascii, this._digit_last_ascii],
            alphaDigits: [this._alpha_lower_first_ascii, this._hex_last_ascii]
          }), e(this, "_dict_ranges", {
            _number_dict_ranges: this._number_dict_ranges,
            _alpha_dict_ranges: this._alpha_dict_ranges,
            _alpha_lower_dict_ranges: this._alpha_lower_dict_ranges,
            _alpha_upper_dict_ranges: this._alpha_upper_dict_ranges,
            _alphanum_dict_ranges: this._alphanum_dict_ranges,
            _alphanum_lower_dict_ranges: this._alphanum_lower_dict_ranges,
            _alphanum_upper_dict_ranges: this._alphanum_upper_dict_ranges,
            _hex_dict_ranges: this._hex_dict_ranges
          }), e(this, "log", (...t) => {
            const s = [...t];
            if (s[0] = "[short-unique-id] ".concat(t[0]), this.debug === !0 && typeof console < "u" && console !== null) {
              console.log(...s);
              return;
            }
          }), e(this, "_normalizeDictionary", (t, s) => {
            let i;
            if (t && Array.isArray(t) && t.length > 1)
              i = t;
            else {
              i = [], this.dictIndex = 0;
              const c = "_".concat(t, "_dict_ranges"), a = this._dict_ranges[c];
              let h = 0;
              for (const [, U] of Object.entries(a)) {
                const [m, E] = U;
                h += Math.abs(E - m);
              }
              i = new Array(h);
              let f = 0;
              for (const [, U] of Object.entries(a)) {
                this.dictRange = U, this.lowerBound = this.dictRange[0], this.upperBound = this.dictRange[1];
                const m = this.lowerBound <= this.upperBound, E = this.lowerBound, q = this.upperBound;
                if (m)
                  for (let I = E; I < q; I++)
                    i[f++] = String.fromCharCode(I), this.dictIndex = I;
                else
                  for (let I = E; I > q; I--)
                    i[f++] = String.fromCharCode(I), this.dictIndex = I;
              }
              i.length = f;
            }
            if (s) {
              const c = i.length;
              for (let a = c - 1; a > 0; a--) {
                const h = Math.floor(Math.random() * (a + 1));
                [i[a], i[h]] = [i[h], i[a]];
              }
            }
            return i;
          }), e(this, "setDictionary", (t, s) => {
            this.dict = this._normalizeDictionary(t, s), this.dictLength = this.dict.length, this.setCounter(0);
          }), e(this, "seq", () => this.sequentialUUID()), e(this, "sequentialUUID", () => {
            const t = this.dictLength, s = this.dict;
            let i = this.counter;
            const c = [];
            do {
              const h = i % t;
              i = Math.trunc(i / t), c.push(s[h]);
            } while (i !== 0);
            const a = c.join("");
            return this.counter += 1, a;
          }), e(this, "rnd", (t = this.uuidLength || v) => this.randomUUID(t)), e(this, "randomUUID", (t = this.uuidLength || v) => {
            if (t === null || typeof t > "u" || t < 1)
              throw new Error("Invalid UUID Length Provided");
            const s = new Array(t), i = this.dictLength, c = this.dict;
            for (let a = 0; a < t; a++) {
              const h = Math.floor(Math.random() * i);
              s[a] = c[h];
            }
            return s.join("");
          }), e(this, "fmt", (t, s) => this.formattedUUID(t, s)), e(this, "formattedUUID", (t, s) => {
            const i = {
              $r: this.randomUUID,
              $s: this.sequentialUUID,
              $t: this.stamp
            };
            return t.replace(/\$[rs]\d{0,}|\$t0|\$t[1-9]\d{1,}/g, (a) => {
              const h = a.slice(0, 2), f = Number.parseInt(a.slice(2), 10);
              return h === "$s" ? i[h]().padStart(f, "0") : h === "$t" && s ? i[h](f, s) : i[h](f);
            });
          }), e(this, "availableUUIDs", (t = this.uuidLength) => Number.parseFloat(([...new Set(this.dict)].length ** t).toFixed(0))), e(this, "_collisionCache", /* @__PURE__ */ new Map()), e(this, "approxMaxBeforeCollision", (t = this.availableUUIDs(this.uuidLength)) => {
            const s = t, i = this._collisionCache.get(s);
            if (i !== void 0)
              return i;
            const c = Number.parseFloat(Math.sqrt(Math.PI / 2 * t).toFixed(20));
            return this._collisionCache.set(s, c), c;
          }), e(this, "collisionProbability", (t = this.availableUUIDs(this.uuidLength), s = this.uuidLength) => Number.parseFloat(
            (this.approxMaxBeforeCollision(t) / this.availableUUIDs(s)).toFixed(20)
          )), e(this, "uniqueness", (t = this.availableUUIDs(this.uuidLength)) => {
            const s = Number.parseFloat(
              (1 - this.approxMaxBeforeCollision(t) / t).toFixed(20)
            );
            return s > 1 ? 1 : s < 0 ? 0 : s;
          }), e(this, "getVersion", () => this.version), e(this, "stamp", (t, s) => {
            const i = Math.floor(+(s || /* @__PURE__ */ new Date()) / 1e3).toString(16);
            if (typeof t == "number" && t === 0)
              return i;
            if (typeof t != "number" || t < 10)
              throw new Error(
                [
                  "Param finalLength must be a number greater than or equal to 10,",
                  "or 0 if you want the raw hexadecimal timestamp"
                ].join(`
`)
              );
            const c = t - 9, a = Math.round(Math.random() * (c > 15 ? 15 : c)), h = this.randomUUID(c);
            return "".concat(h.substring(0, a)).concat(i).concat(h.substring(a)).concat(a.toString(16));
          }), e(this, "parseStamp", (t, s) => {
            if (s && !/t0|t[1-9]\d{1,}/.test(s))
              throw new Error("Cannot extract date from a formated UUID with no timestamp in the format");
            const i = s ? s.replace(/\$[rs]\d{0,}|\$t0|\$t[1-9]\d{1,}/g, (a) => {
              const h = {
                $r: (m) => [...Array(m)].map(() => "r").join(""),
                $s: (m) => [...Array(m)].map(() => "s").join(""),
                $t: (m) => [...Array(m)].map(() => "t").join("")
              }, f = a.slice(0, 2), U = Number.parseInt(a.slice(2), 10);
              return h[f](U);
            }).replace(/^(.*?)(t{8,})(.*)$/g, (a, h, f) => t.substring(h.length, h.length + f.length)) : t;
            if (i.length === 8)
              return new Date(Number.parseInt(i, 16) * 1e3);
            if (i.length < 10)
              throw new Error("Stamp length invalid");
            const c = Number.parseInt(i.substring(i.length - 1), 16);
            return new Date(Number.parseInt(i.substring(c, c + 8), 16) * 1e3);
          }), e(this, "setCounter", (t) => {
            this.counter = t;
          }), e(this, "validate", (t, s) => {
            const i = s ? this._normalizeDictionary(s) : this.dict;
            return t.split("").every((c) => i.includes(c));
          });
          const d = x(x({}, P), r);
          this.counter = 0, this.debug = !1, this.dict = [], this.version = $;
          const { dictionary: D, shuffle: w, length: R, counter: V } = d;
          this.uuidLength = R, this.setDictionary(D, w), this.setCounter(V), this.debug = d.debug, this.log(this.dict), this.log(
            "Generator instantiated with Dictionary Size ".concat(this.dictLength, " and counter set to ").concat(this.counter)
          ), this.log = this.log.bind(this), this.setDictionary = this.setDictionary.bind(this), this.setCounter = this.setCounter.bind(this), this.seq = this.seq.bind(this), this.sequentialUUID = this.sequentialUUID.bind(this), this.rnd = this.rnd.bind(this), this.randomUUID = this.randomUUID.bind(this), this.fmt = this.fmt.bind(this), this.formattedUUID = this.formattedUUID.bind(this), this.availableUUIDs = this.availableUUIDs.bind(this), this.approxMaxBeforeCollision = this.approxMaxBeforeCollision.bind(this), this.collisionProbability = this.collisionProbability.bind(this), this.uniqueness = this.uniqueness.bind(this), this.getVersion = this.getVersion.bind(this), this.stamp = this.stamp.bind(this), this.parseStamp = this.parseStamp.bind(this);
        }
      };
      e(y, "default", y);
      var B = y;
      return j(S);
    })();
    u.exports = n.default, typeof window < "u" && (n = n.default);
  })(C)), C.exports;
}
var Z = K();
const Q = /* @__PURE__ */ J(Z), L = new Q({ length: 10 });
class M {
  constructor(n, o) {
    this.onMessageHandlers = [], this.message = (l, p, g) => this.crossOrigin ? this.postMessage(l, p, g) : this.customEventMessage(l, p, g), this.channelId = n ?? G, this.channelNodeId = `channel-node-${L.rnd()}`, this.crossOrigin = o, this.connection = new Promise((l) => {
      this.resolveConnection = l;
    }), this.boundMessageHandler = this.handleMessage.bind(this);
  }
  /**
   * Remove event listener from the window
   */
  disconnect() {
    this.onMessageHandlers = [], window.removeEventListener(this.channelId, this.boundMessageHandler), this.connection = new Promise((n) => {
      this.resolveConnection = n;
    });
  }
  /**
   * Takes a callback which gets triggered whenever an event is received.
   * All the message handlers are store in 'onMessageHandlers'.
   */
  onMessage(n) {
    this.onMessageHandlers.push(n);
  }
  /**
   * Removes a message handler from the 'onMessageHandlers' array.
   */
  removeMessageHandler(n) {
    const o = this.onMessageHandlers.findIndex(
      (l) => l === n
    );
    this.onMessageHandlers.splice(o, 1);
  }
  customEventMessage(n, o, l) {
    const p = new CustomEvent(this.channelId, {
      detail: {
        eventId: l,
        channelId: this.channelId,
        channelNodeId: this.channelNodeId,
        name: n,
        data: o
      }
    });
    window.dispatchEvent(p);
  }
  postMessage(n, o, l) {
    if (!this.crossOrigin?.targetOrigin) {
      console.error("A target origin was not specified.");
      return;
    }
    this.crossOrigin?.window?.postMessage(
      {
        eventId: l,
        channelId: this.channelId,
        channelNodeId: this.channelNodeId,
        name: n,
        data: o
      },
      this.crossOrigin?.targetOrigin
    );
  }
  /**
   * Sends a message event, and resolves when it receives a response. This is
   * similar to an HTTP request.
   */
  async eventRequest(n, o) {
    const l = L.rnd();
    return new Promise((p) => {
      const g = (b) => {
        const { eventId: N } = b;
        l === N && (this.removeMessageHandler(g), p(b));
      };
      this.onMessage(g), this.message(n, o, l);
    });
  }
  /**
   * A Promise wrapper around onMessage. 'waitForEvent' will resolve 'data' when
   * it receives an event corresponding to 'eventName'.
   */
  async waitForEvent(n) {
    return new Promise((o) => {
      const l = (p) => {
        const { name: g } = p;
        n === g && (this.removeMessageHandler(l), o(p));
      };
      this.onMessage(l);
    });
  }
  /**
   * Triggers the onMessageHandlers.
   */
  handleMessage(n) {
    let o;
    if (M.isCustomEvent(n))
      o = n.detail;
    else {
      if (this.crossOrigin && !this.crossOrigin.targetOrigin.includes(n.origin) && // If the targetOrigin is set to "*", aka "wildcard", any event.origin
      // should be accepted.
      this.crossOrigin?.targetOrigin !== "*")
        return;
      o = n.data;
    }
    const {
      channelId: l,
      channelNodeId: p
    } = o;
    this.channelId === l && this.channelNodeId !== p && this.onMessageHandlers.forEach((g) => {
      g(o);
    });
  }
  static isCustomEvent(n) {
    return n.detail !== void 0;
  }
}
class X extends M {
  connect(n) {
    return window.addEventListener(
      this.crossOrigin ? "message" : this.channelId,
      this.boundMessageHandler
    ), this.waitForEvent(A).then((o) => {
      this.message("CONNECTION_EVENT_RESPONSE", n, o.eventId), this.resolveConnection(o);
    }), this.connection;
  }
}
class Y extends M {
  connect() {
    return window.addEventListener(
      this.crossOrigin ? "message" : this.channelId,
      this.boundMessageHandler
    ), this.eventRequest(A).then((n) => {
      this.resolveConnection(n);
    }), this.connection;
  }
}
export {
  z as ChannelEvents,
  Y as FollowerNode,
  X as LeaderNode
};
